module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nEBoJL/tc-custom/9781646562671.jpg?1723405272258",
      "alt": "This image is the cover for the book Bended Knee"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bended Knee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When restaurateur Hugh Neumann rebukes Oliver Nicholas’s very public proposal to his boyfriend during a Valentine’s Day dinner, the diverted Cupid’s arrow strikes Hugh not in the heart, but in the ass."), _c('br'), _c('br'), _vm._v("After a media storm of commentary, ironically pro and con, gains national steam, what Hugh begins to refer to as his personal “St. Valentine’s Day Massacre” begins to affect home life with his partner, Dominick Brodie."), _c('br'), _c('br'), _vm._v("Was Hugh’s overreaction pandering to his largely heterosexual clientele? Or did the incident trigger his own panic about same-sex marriage? Will the public scrutiny threaten his decade-long commitment to Dom?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rodney Ross\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0